import Swiper from "swiper";
import { Pagination, EffectCreative, Keyboard, Mousewheel, Navigation, Thumbs, EffectFade, Autoplay, EffectCoverflow, Grid, FreeMode } from "swiper/modules";

/**
 * @param swiperInit
 */
export default function swiperInit() {

	$(".home-cols-1 .swiper").each(function () {
		new Swiper(this, {
			modules: [Pagination, Autoplay, Navigation],
			slidesPerView: 1,
			speed: 1000,
			effect: "fade",
			// autoplay: {
			// 	delay: 3500,
			// },
			// loop: true,
			pagination: {
				el: $(this).closest('.home-cols-1').find('.swiper-pagination')[0],
				clickable: true,
			},
			navigation: {
				nextEl: $(this).closest(".home-cols-1").find(".btn-next")[0],
				prevEl: $(this).closest(".home-cols-1").find(".btn-prev")[0],
			},
		});
	});

	$(".home-cols-swiper-marquee .swiper").each(function () {
		new Swiper(this, {
			modules: [Autoplay],
			slidesPerView: 'auto',
			spaceBetween: 16,
			speed: 3000,
			loop: true,
			allowTouchMove: false,
			autoplay: {
				delay: 0,
				disableOnInteraction: false,
				pauseOnMouseEnter: false,
			},
		});
	});

	$(".home-cols-brand .swiper").each(function () {
		new Swiper(this, {
			modules: [Pagination, Autoplay, Navigation],
			slidesPerView: 2,
			spaceBetween: 20,
			speed: 3500,
			autoplay: {
				delay: 0,
				disableOnInteraction: false,
			},
			loop: true,
			breakpoints: {
				768: {
					slidesPerView: 6,
				},
				1200: {
					slidesPerView: 8,
				},
			},
		});
	});

	$(".home-cols-new .swiper").each(function () {
		new Swiper(this, {
			modules: [Pagination, Autoplay, Navigation],
			slidesPerView: 1,
			spaceBetween: 32,
			// loopAdditionalSlides: 10,
			autoplay: {
				delay: 3500,
			},
			loop: true,
			navigation: {
				nextEl: $(this).closest(".home-cols-new").find(".btn-next")[0],
				prevEl: $(this).closest(".home-cols-new").find(".btn-prev")[0],
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 3,
				},
				1290: {
					slidesPerView: 3.8,
					// slidesPerGroup: 1,  // PHẢI LÀ SỐ NGUYÊN (1 thay vì 1.4)
				},
			},
		});
	});

	$(".home-cols-actives .swiper").each(function () {
		new Swiper(this, {
			modules: [Pagination, Autoplay, Navigation],
			slidesPerView: 1,
			spaceBetween: 32,
			// loopAdditionalSlides: 10,
			autoplay: {
				delay: 3500,
			},
			loop: true,
			navigation: {
				nextEl: $(this).closest(".home-cols-actives").find(".btn-next")[0],
				prevEl: $(this).closest(".home-cols-actives").find(".btn-prev")[0],
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 3,
				},
				1200: {
					slidesPerView: 4.1,
					// slidesPerGroup: 1,  // PHẢI LÀ SỐ NGUYÊN (1 thay vì 1.4)
				},
			},
		});
	});

	$(".slide-time-line .swiper").each(function () {
		new Swiper(this, {
			modules: [Pagination, Autoplay, Navigation],
			slidesPerView: 1.5,
			spaceBetween: 30,
			slidesPerGroup: 1,
			// autoplay: {
			// 	delay: 4000,
			// },
			// loop: true,
			pagination: {
				el: $(this).closest('.slide-time-line').find('.swiper-pagination')[0],
				clickable: true,
			},
			navigation: {
				nextEl: $(this).closest(".slide-time-line").find(".btn-next")[0],
				prevEl: $(this).closest(".slide-time-line").find(".btn-prev")[0],
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				1200: {
					slidesPerView: 4,
				},
			},
		});
	});


	$(".home-cols-2 .swiper").each(function () {
		new Swiper(this, {
			modules: [Pagination, Autoplay, Navigation],
			slidesPerView: 1,
			spaceBetween: 40,
			autoplay: {
				delay: 4000,
			},
			loop: true,
			pagination: {
				el: $(this).closest('.home-cols-2').find('.swiper-pagination')[0],
				clickable: true,
			},
			navigation: {
				nextEl: $(this).closest(".home-cols-2").find(".btn-next")[0],
				prevEl: $(this).closest(".home-cols-2").find(".btn-prev")[0],
			},
			breakpoints: {
				768: {
					slidesPerView: 1,
				},
				1200: {
					slidesPerView: 2,
				},
			},
		});
	});

	$(".home-cols-3 .swiper").each(function () {
		new Swiper(this, {
			modules: [Pagination, Autoplay, Navigation],
			slidesPerView: 1,
			spaceBetween: 33,
			autoplay: {
				delay: 4000,
			},
			loop: true,
			pagination: {
				el: $(this).closest('.home-cols-3').find('.swiper-pagination')[0],
				clickable: true,
			},
			navigation: {
				nextEl: $(this).closest(".home-cols-3").find(".btn-next")[0],
				prevEl: $(this).closest(".home-cols-3").find(".btn-prev")[0],
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				1200: {
					slidesPerView: 3,
				},
			},
		});
	});

	const swiperInstances = [];
	$(".home-cols-3-gallery .swiper").each(function () {
		const swiper = new Swiper(this, {
			modules: [Pagination, Autoplay, Navigation],
			slidesPerView: "auto",
			spaceBetween: 33,
			loop: true,
			autoplay: false,

			navigation: {
				nextEl: $(this).closest(".home-cols-3-gallery").find(".btn-next")[0],
				prevEl: $(this).closest(".home-cols-3-gallery").find(".btn-prev")[0],
			},

			// breakpoints: {
			// 	768: { slidesPerView: 2 },
			// 	1200: { slidesPerView: 3 },
			// },
		});

		swiperInstances.push(swiper);
	});

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				const swiperEl = entry.target.querySelector(".swiper");
				if (!swiperEl || !swiperEl.swiper) return;

				const swiper = swiperEl.swiper;

				if (entry.isIntersecting) {
					swiper.params.autoplay = {
						delay: 4000,
						disableOnInteraction: false,
					};
					swiper.autoplay.start();
				} else {
					swiper.autoplay.stop();
				}
			});
		},
		{
			threshold: 0.5,
		}
	);

	// observe từng item
	document.querySelectorAll(".home-cols-3-gallery").forEach((item) => {
		observer.observe(item);
	});

	$(".home-cols-4 .swiper").each(function () {
		new Swiper(this, {
			modules: [Pagination, Autoplay, Navigation],
			slidesPerView: 1,
			spaceBetween: 40,
			autoplay: {
				delay: 4000,
			},
			loop: true,
			pagination: {
				el: $(this).closest('.home-cols-4').find('.swiper-pagination')[0],
				clickable: true,
			},
			navigation: {
				nextEl: $(this).closest(".home-cols-4").find(".btn-next")[0],
				prevEl: $(this).closest(".home-cols-4").find(".btn-prev")[0],
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				1200: {
					slidesPerView: 4,
				},
			},
		});
	});

	$(".home-cols-5 .swiper").each(function () {
		new Swiper(this, {
			modules: [Pagination, Autoplay, Navigation],
			slidesPerView: 2,
			spaceBetween: 40,
			autoplay: {
				delay: 4000,
			},
			loop: true,
			pagination: {
				el: $(this).closest('.home-cols-5').find('.swiper-pagination')[0],
				clickable: true,
			},
			navigation: {
				nextEl: $(this).closest(".home-cols-5").find(".btn-next")[0],
				prevEl: $(this).closest(".home-cols-5").find(".btn-prev")[0],
			},
			breakpoints: {
				768: {
					slidesPerView: 3,
				},
				1200: {
					slidesPerView: 5,
				},
			},
		});
	});



	// slider gallery
	var sliderThumbnail = new Swiper('.thumb-slider .swiper', {
		modules: [Autoplay, Navigation],
		loop: true,
		autoplay: {
			delay: 4000,
		},
		slidesPerView: 4,
		spaceBetween: 30,
		freeMode: true,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,

	});
	var mainSlider = new Swiper('.main-slider .swiper', {
		modules: [Thumbs, Autoplay, Navigation],
		navigation: {
			nextEl: '.thumb-slider .btn-next',
			prevEl: '.thumb-slider .btn-prev',
		},
		autoplay: {
			delay: 4000,
		},
		loop: true,
		thumbs: {
			swiper: sliderThumbnail
		}
	});
	// end



}
